/// <amd-module name="TFS/Admin/Views/OrgGroups/redux/OrganizationGroupsRootProviderProps" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IRootProviderProps } from "VSS/Redux/RootProvider";

export interface IGroupsHubSagaContext {
    pageContext: IVssPageContext;
}

export function getGroupsHubRootProviderProps(pageContext: IVssPageContext): IRootProviderProps<IGroupsHubSagaContext, any> {
    const initialState = {};

    const sagaContext = { pageContext };

    return {
        initialState,
        sagaContext,
        scenarioName: "GroupsHub",
        modules: []
    };
}
